<mat-form-field class="example-form-field" appearance="fill">
  <mat-date-range-input [formGroup]="datePickerGroup" [rangePicker]="campaignOnePicker">
    <input matStartDate placeholder="Start date" formControlName="start" [(ngModel)]="dateRange.startDate">
    <input matEndDate placeholder="End date" formControlName="end" [(ngModel)]="dateRange.endDate" (dateChange)="onChange($event)">
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
  <mat-date-range-picker #campaignOnePicker></mat-date-range-picker>
</mat-form-field>
<div class="p-2 pull-right">
  <button class="btn btn-sm bg-g-red" (click)="onClick()">Clear</button>
</div>
